export default __webpack_public_path__ + "static/media/gogo-logo.f5006e6b.svg";